<template>
  <a-modal
    v-model="isVisible"
    :footer="null"
    title="Proceso de Captura de Firma"
    @cancel="$emit('cancel')"
    :width="500"
  >
    <div ref="wacom-signature-pad" style="height: 320px"></div>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue'

import { WacomSignaturePad } from '@lumile/lumbre-wacom-sginature-pad'
import { mapGetters } from 'vuex'

export default defineComponent({
  props: {
    isProcessing: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isVisible: false,

    blob: null
  }),

  computed: {
    ...mapGetters('settings', ['wacom'])
  },

  methods: {
    onCancel () {
      this.isVisible = false
      this.$emit('cancel')
    },
    onConfirm (event) {
      this.$emit('confirm', event)
    },
    open (who, why, extraData = null) {
      this.isVisible = true

      this.$nextTick(() => {
        // Licencia de demo
        // const key = `eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJiMzNhYWUyODA0NmM0MmE5OTgyY2E1NTdkZjhmY2YxOCIsImV4cCI6MTY3ODk1OTEwNCwiaWF0IjoxNjcxMTgzMTMyLCJzZWF0cyI6MCwicmlnaHRzIjpbIkpTX0NPUkUiLCJTSUdfU0RLX0NPUkUiLCJTSUdfU0RLX0lTTyIsIlNJR19TREtfRU5DUlBZVElPTiJdLCJkZXZpY2VzIjpbIldBQ09NX0FOWSJdLCJ0eXBlIjoiZXZhbCIsImxpY19uYW1lIjpudWxsLCJ3YWNvbV9pZCI6ImIzM2FhZTI4MDQ2YzQyYTk5ODJjYTU1N2RmOGZjZjE4IiwibGljX3VpZCI6ImFmYzkyNGIyLTBiZTItNDAyZC1hYTA0LWRiZDY0MDdlYTc4MCIsImFwcHNfd2luZG93cyI6W10sImFwcHNfaW9zIjpbXSwiYXBwc19hbmRyb2lkIjpbXSwibWFjaGluZV9pZHMiOltdfQ.M2Cphus6EWDxKlwQspqtDjlAUPu_aXZ2SjyEPVqtw6iLlwCizyg9-2oPVGvEy5-h-Mr1oFzzOe4IvWhwYDaCRj1llvRaZmbWplXD0iyVrMp4RLhVV1MsLt4MUvWMj9yJDEs5Q1UP6bBr0A3PXwL2r1jho-jUiNWjqmPbWt_ER92MPzsKtxunfxEvvstDJKT8VXpVGdBmu2Qqv__QROPfJRo_DvR9tPP1HCk8HJJCvfqHcKuiFecoqhm1hZFiwSb0Upg5Ei4T1aT4kVH_py8sZ_54HQJjgLzNRvFmm0RHXbUVe-pcuChclJW0EH_fGKjQL3VCWjrU8YXX7howXTlYZA`

        // Licencia de WACOM para el SDKjs
        let wacomLicense = this.wacom.sdkLicense || {
          key: '2646fb1b-b500-4f9a-96bb-97d5c189d48b',
          secret: '+KAEUMaBIK2N3CbGL7IUtF1sz/OpimButFxliN0RjK+k2p5zV20cUxC9tNzbWuHSs9boHmLocGgFJMFmrEeahw=='
        }

        // Clave pública con la cual se va a encriptar el contenido de los archivos con la captura de firma
        // biometrica iso 19794
        const publicKey = this.wacom.encryptionPublicKey || `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8RNt0cdeZbYcrfYvJg1r
Y9ChK9U1bnDFtAPqA9FWygUFVgOMxDyBWmMrDK/pDftYsBhzYcOOGIJbnHRu3sAa
RK6gz9pCDAwyrdfiDXWaoEbHZ9lrtandklfAOQs0vm+VTsoyjzfu9q8O1SUxkQWw
0nSxD/3MEKa1fikfQl82ohHwcxQZXY1DqG0nA4LhVFBgCrtBA78WpjF13OP65DlX
aCJ0I1vaoYN7xx8PgCIpbeSwuCScU19rciOAaWBpmr8NkAUT3s3Oi69dh0RZNvWW
IQcecNnOsgmuWnw5+mR16rYLTS0xZr/FdWnjgAXBd/KeQhMbqenC0chVIwj/Z2x6
RQIDAQAB
-----END PUBLIC KEY-----`

        const WSP = new WacomSignaturePad(wacomLicense, publicKey, this.$refs['wacom-signature-pad'], who, why, extraData)

        WSP.render()

        WSP.addEventListener('file', (event) => {
          this.blob = event.file
        })

        WSP.addEventListener('cancel', (event) => {
          this.onCancel()
        })
      })

      return new Promise((resolve, reject) => {
        this.$on('confirm', (event) => {
          resolve(event)
        })
        this.$on('cancel', () => {
          reject(new Error('cancel'))
        })
      })
    }
  },

  watch: {
    blob (val) {
      if (val) {
        this.$emit('confirm', val)
        this.isVisible = false
      }
    }
  }
})
</script>
